import React from 'react';
import { Box, GuideDot, InfoIcon } from 'edenred-ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { useOnboardingWizard } from '@epi-shared/hooks';

const MyChoiceDisclaimerTitle = () => {
  const { t } = useTranslation();
  const { sizeExtraLarge, fontSemiBold, primaryFrontColor } = useTheme();
  const { isOnBoardingActive } = useOnboardingWizard();

  return (
    <Box
      p={2}
      color={primaryFrontColor}
      fontSize={sizeExtraLarge}
      fontWeight={fontSemiBold}
      alignItems={'center'}
      display={'flex'}
      gap={1}
      position="relative"
    >
      <InfoIcon color={primaryFrontColor} />
      {t('containers.benefit_groups.my_choice_disclaimer.title')}
      {isOnBoardingActive && (
        <Box position="absolute" top={10} right={-30}>
          <GuideDot
            storageKey="my-choice-guide-dot"
            tooltipDescription={t('guided_tour.my_choice')}
            tooltipSide="top"
          />
        </Box>
      )}
    </Box>
  );
};

export { MyChoiceDisclaimerTitle };
